import { basePadding } from "@Constants/baseStyles"
import React from "react"
import { Dimensions, ScrollView } from "react-native"

const { width, height } = Dimensions.get("screen")
export const CustomScrollview = (props) => {
    const { contentContainerStyle } = props
    return (
        <ScrollView
            keyboardShouldPersistTaps="handled"
            nestedScrollEnabled={true}
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{
                paddingTop: props.paddingTop != undefined ? props.paddingTop : basePadding.paddingVertical,
                paddingBottom: props.paddingBottom ? props.paddingBottom : 200,
                ...contentContainerStyle
            }}
        >
            {props.children}
        </ScrollView>
    )
}
